export function dateFromTodayOffset(offset: number | undefined, today = new Date()): string {
  const date = new Date(Date.UTC(today.getFullYear(), today.getMonth(), today.getDate()))
  date.setUTCDate(date.getUTCDate() + (offset || 0))
  return date.toISOString().slice(0, 10)
}

export function formatDateAnswer(value: string, min: string, max: string): string | null {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value) || value < min || value > max) return null
  const date = new Date(`${value}T00:00:00.000Z`)
  if (Number.isNaN(date.getTime()) || date.toISOString().slice(0, 10) !== value) return null
  return date.toISOString()
}
